import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HtmlPageComponent } from './html-page.component';

@NgModule({
    imports: [CommonModule],
    declarations: [HtmlPageComponent],
    entryComponents: [HtmlPageComponent],
    exports: [HtmlPageComponent]
})
export class HtmlPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/files/html-page/html-page.module.ts